import axios from 'axios';
import {
  commonRequestConfig,
  commonRequestInterceptors,
  commonResponseInterceptors,
} from './commonConfig';

// 创建请求实例，允许不同的实例设置不同的配置，这些配置会和默认配置合并
function createInstance(
  config,
  requestInterceptors,
  responseInterceptors
) {
  const instance = axios.create({
    ...commonRequestConfig,
    ...config,
  });

  const allRequestInterceptors = [
    ...commonRequestInterceptors,
    ...requestInterceptors,
  ];

  // 设置所有请求拦截器
  allRequestInterceptors.forEach((requestInterceptor) => {
    instance.interceptors.request.use(
      requestInterceptor.onFulfilled,
      requestInterceptor.onRejected
    );
  });

  const allResponseInterceptors = [
    ...commonResponseInterceptors,
    ...responseInterceptors,
  ];

  // 设置所有响应拦截器
  allResponseInterceptors.forEach((responseInterceptor) => {
    instance.interceptors.response.use(
      responseInterceptor.onFulfilled,
      responseInterceptor.onRejected
    );
  });

  // 导出常用函数

  /**
   * @param {string} url
   * @param {object} data
   * @param {object} config
   */
  function post(url, data = {}, config = {}) {
    return instance.post(url, data, config);
  }

  /**
   * @param {string} url
   * @param {object} config
   */
  function get(url, config = {}) {
    return instance.get(url, config);
  }

  /**
   * @param {string} url
   * @param {object} data
   * @param {object} config
   */
  function put(url, data = {}, config = {}) {
    return instance.put(url, data, config);
  }

  /**
   * @param {string} url
   * @param {object} config
   */
  function _delete(url, config = {}) {
    return instance.delete(url, config);
  }

  return {
    instance,
    post,
    get,
    put,
    _delete,
  };
}

export default createInstance;
